import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';

import { ReactComponent as UserXIcon } from '@repo/common/assets/icons/16px/icon_16px_user-x_outline.svg';
import { ReactComponent as UserCheckIcon } from '@repo/common/assets/icons/16px/icon_16px_user-check_outline.svg';
import { ReactComponent as CrownIcon } from '@repo/common/assets/icons/16px/icon_16px_crown_outline.svg';
import { ReactComponent as MailIcon } from '@repo/common/assets/icons/16px/icon_16px_mail_outline.svg';
import { ReactComponent as PhoneIcon } from '@repo/common/assets/icons/16px/icon_16px_phone_outline.svg';
import { ReactComponent as XCircleIcon } from '@repo/common/assets/icons/16px/icon_16px_x-circle_outline.svg';
import { ReactComponent as UserMinusIcon } from '@repo/common/assets/icons/16px/icon_16px_user-minus_outline.svg';
import { ReactComponent as SettingIcon } from '@repo/common/assets/icons/16px/icon_16px_setting_outline.svg';
import { ReactComponent as NavigationUpIcon } from '@repo/common/assets/icons/16px/icon_16px_navigation-up.svg';
import { ReactComponent as NavigationDownIcon } from '@repo/common/assets/icons/16px/icon_16px_navigation-down.svg';
import { ReactComponent as UndoIcon } from '@repo/common/assets/icons/16px/icon_16px_undo-left.svg';

import { BaseButton } from '@repo/common';

function WorkshopDetailOptionList({
  anchorRect,
  onClose,
  onMarkAttended,
  onMarkAbsent,
  onMarkNoShow,
  onMarkLate,
  onContact,
  onConfirmationEmail,
  onBlockUser,
  onUnblockUser,
  onBlockAgainUser,
  onAssignMvp,
  onRemoveMvp,
  onCancelBooking,
  onRemoveWaitlist,
  onMoveUpWaitlist,
  onMoveDownWaitlist,
  onSendOffer,
  onOfferSpot,
  onViewInvoice,
  status,
  blockStatus,
  type,
  isBlocked,
  isMvp,
  isPending,
}) {
  const listRef = useRef(null);

  useEffect(() => {
    if (!anchorRect) return;

    const handleScroll = () => onClose?.();

    window.addEventListener('scroll', handleScroll, true);
    return () => window.removeEventListener('scroll', handleScroll, true);
  }, [anchorRect, onClose]);

  if (!anchorRect) return null;

  const handleItemClick = async (e, action) => {
    e.preventDefault();
    e.stopPropagation();

    if (action === 'markAttended') {
      onMarkAttended?.();
      onClose?.();
      return;
    }
    if (action === 'markAbsent') {
      onMarkAbsent?.();
      onClose?.();
      return;
    }
    if (action === 'markNoShow') {
      onMarkNoShow?.();
      onClose?.();
      return;
    }
    if (action === 'markLate') {
      onMarkLate?.();
      onClose?.();
      return;
    }
    if (action === 'contact') {
      onContact?.();
      onClose?.();
      return;
    }
    if (action === 'sendConfirmation') {
      onConfirmationEmail?.();
      onClose?.();
      return;
    }
    if (action === 'block') {
      onBlockUser?.();
      onClose?.();
      return;
    }
    if (action === 'unBlock') {
      onUnblockUser?.();
      onClose?.();
      return;
    }
    if (action === 'blockAgain') {
      onBlockAgainUser?.();
      onClose?.();
      return;
    }
    if (action === 'assignMvp') {
      onAssignMvp?.();
      onClose?.();
      return;
    }
    if (action === 'removeMvp') {
      onRemoveMvp?.();
      onClose?.();
      return;
    }
    if (action === 'cancelBooking') {
      onCancelBooking?.();
      onClose?.();
      return;
    }
    if (action === 'removeWaitlist') {
      onRemoveWaitlist?.();
      onClose?.();
      return;
    }
    if (action === 'moveUp') {
      onMoveUpWaitlist?.();
      onClose?.();
      return;
    }
    if (action === 'moveDown') {
      onMoveDownWaitlist?.();
      onClose?.();
      return;
    }
    if (action === 'sendOffer') {
      onSendOffer?.();
      onClose?.();
      return;
    }
    if (action === 'offerSpot') {
      onOfferSpot?.();
      onClose?.();
      return;
    }
    if (action === 'payments') {
      onViewInvoice?.();
      onClose?.();
      return;
    }
  };

  return (
    <>
      {anchorRect &&
        ReactDOM.createPortal(
          <>
            <div
              className='fixed inset-0 z-[999999] bg-transparent'
              onClick={(e) => {
                e.stopPropagation();
                onClose?.();
              }}
            />

            <div
              ref={listRef}
              onClick={(e) => e.stopPropagation()}
              style={{
                position: 'fixed',
                top: anchorRect.bottom + 6,
                left:
                  anchorRect.right -
                  (type === 'confirmed' || type === 'waitlisted' ? 241 : 200),
              }}
              className={`
                ${
                  type === 'confirmed' || type === 'waitlisted'
                    ? 'w-[241px]'
                    : 'w-[200px]'
                }
                bg-grayscale-gray00 
                border border-grayscale-gray02 
                rounded-lg
                shadow-popup-04
                z-[1000000]
              `}
            >
              <div className='bg-grayscale-gray00 rounded-lg p-2'>
                <ul className='flex flex-col'>
                  {(status === 'ATTENDED' ||
                    status === 'CONFIRMED' ||
                    status === 'ABSENT') && (
                    <>
                      {(status === 'CONFIRMED' || status === 'ABSENT') && (
                        <li>
                          <BaseButton
                            type='text'
                            size='m'
                            iconPosition='after'
                            icon={<UserCheckIcon />}
                            width='100%'
                            separate={true}
                            leftalign={true}
                            onClick={(e) => handleItemClick(e, 'markAttended')}
                            bgclass={`bg-grayscale-gray00 border border-grayscale-gray00 pr-2 hover:bg-grayscale-gray01 hover:text-grayscale-gray07
                              active:bg-grayscale-gray01 active:text-grayscale-gray07`}
                            textclass='typo-b14Strong'
                          >
                            Mark as attended
                          </BaseButton>
                        </li>
                      )}

                      {status !== 'ABSENT' && (
                        <li>
                          <BaseButton
                            type='text'
                            size='m'
                            iconPosition='after'
                            icon={<UserXIcon />}
                            width='100%'
                            separate={true}
                            leftalign={true}
                            onClick={(e) => handleItemClick(e, 'markAbsent')}
                            bgclass={`bg-grayscale-gray00 border border-grayscale-gray00 pr-2 hover:bg-grayscale-gray01 hover:text-grayscale-gray07
                            active:bg-grayscale-gray01 active:text-grayscale-gray07`}
                            textclass='typo-b14Strong'
                          >
                            Mark as absent
                          </BaseButton>
                        </li>
                      )}

                      {status !== 'ABSENT' && (
                        <li>
                          <BaseButton
                            type='text'
                            size='m'
                            iconPosition='after'
                            icon={<UserCheckIcon />}
                            width='100%'
                            separate={true}
                            leftalign={true}
                            onClick={(e) => handleItemClick(e, 'markLate')}
                            bgclass={`bg-grayscale-gray00 border border-grayscale-gray00 pr-2 hover:bg-grayscale-gray01 hover:text-grayscale-gray07
                              active:bg-grayscale-gray01 active:text-grayscale-gray07`}
                            textclass='typo-b14Strong'
                          >
                            Mark as late
                          </BaseButton>
                        </li>
                      )}

                      <li>
                        <BaseButton
                          type='text'
                          size='m'
                          iconPosition='after'
                          icon={<UserXIcon />}
                          width='100%'
                          separate={true}
                          leftalign={true}
                          onClick={(e) => handleItemClick(e, 'markNoShow')}
                          bgclass={`bg-grayscale-gray00 border border-grayscale-gray00 pr-2 hover:bg-grayscale-gray01 hover:text-grayscale-gray07
                            active:bg-grayscale-gray01 active:text-grayscale-gray07`}
                          textclass='typo-b14Strong'
                        >
                          Mark as no-show
                        </BaseButton>
                      </li>

                      {status === 'ATTENDED' && status !== 'ABSENT' && (
                        <>
                          {isMvp ? (
                            <li>
                              <BaseButton
                                type='text'
                                size='m'
                                iconPosition='after'
                                icon={<CrownIcon />}
                                width='100%'
                                separate={true}
                                leftalign={true}
                                onClick={(e) => handleItemClick(e, 'removeMvp')}
                                bgclass={`bg-grayscale-gray00 border border-grayscale-gray00 pr-2 hover:bg-grayscale-gray01 hover:text-grayscale-gray07
                            active:bg-grayscale-gray01 active:text-grayscale-gray07`}
                                textclass='typo-b14Strong'
                              >
                                Remove MVP
                              </BaseButton>
                            </li>
                          ) : (
                            <li>
                              <BaseButton
                                type='text'
                                size='m'
                                iconPosition='after'
                                icon={<CrownIcon />}
                                width='100%'
                                separate={true}
                                leftalign={true}
                                onClick={(e) => handleItemClick(e, 'assignMvp')}
                                bgclass={`bg-grayscale-gray00 border border-grayscale-gray00 pr-2 hover:bg-grayscale-gray01 hover:text-grayscale-gray07
                              active:bg-grayscale-gray01 active:text-grayscale-gray07`}
                                textclass='typo-b14Strong'
                              >
                                Assign MVP
                              </BaseButton>
                            </li>
                          )}
                        </>
                      )}

                      {status !== 'ABSENT' && (
                        <li>
                          <BaseButton
                            type='text'
                            size='m'
                            iconPosition='after'
                            icon={<MailIcon />}
                            width='100%'
                            separate={true}
                            leftalign={true}
                            onClick={(e) =>
                              handleItemClick(e, 'sendConfirmation')
                            }
                            bgclass={`bg-grayscale-gray00 border border-grayscale-gray00 pr-2 hover:bg-grayscale-gray01 hover:text-grayscale-gray07
                            active:bg-grayscale-gray01 active:text-grayscale-gray07`}
                            textclass='typo-b14Strong'
                          >
                            Send confirmation email
                          </BaseButton>
                        </li>
                      )}
                    </>
                  )}

                  {type === 'canceled' && (
                    <>
                      <li>
                        <BaseButton
                          type='text'
                          size='m'
                          iconPosition='after'
                          icon={<SettingIcon />}
                          width='100%'
                          separate={true}
                          leftalign={true}
                          onClick={(e) => handleItemClick(e, 'payments')}
                          bgclass={`bg-grayscale-gray00 border border-grayscale-gray00 pr-2 hover:bg-grayscale-gray01 hover:text-grayscale-gray07
                            active:bg-grayscale-gray01 active:text-grayscale-gray07`}
                          textclass='typo-b14Strong'
                        >
                          Go to payments
                        </BaseButton>
                      </li>
                    </>
                  )}

                  {type === 'waitlisted' && !isPending && (
                    <>
                      <li>
                        <BaseButton
                          type='text'
                          size='m'
                          iconPosition='after'
                          icon={<UserCheckIcon />}
                          width='100%'
                          separate={true}
                          leftalign={true}
                          onClick={(e) => handleItemClick(e, 'offerSpot')}
                          bgclass={`bg-grayscale-gray00 border border-grayscale-gray00 pr-2 hover:bg-grayscale-gray01 hover:text-grayscale-gray07
                            active:bg-grayscale-gray01 active:text-grayscale-gray07`}
                          textclass='typo-b14Strong'
                        >
                          Offer spot
                        </BaseButton>
                      </li>

                      <li>
                        <BaseButton
                          type='text'
                          size='m'
                          iconPosition='after'
                          icon={<NavigationUpIcon />}
                          width='100%'
                          separate={true}
                          leftalign={true}
                          onClick={(e) => handleItemClick(e, 'moveUp')}
                          bgclass={`bg-grayscale-gray00 border border-grayscale-gray00 pr-2 hover:bg-grayscale-gray01 hover:text-grayscale-gray07
                            active:bg-grayscale-gray01 active:text-grayscale-gray07`}
                          textclass='typo-b14Strong'
                        >
                          Move up
                        </BaseButton>
                      </li>

                      <li>
                        <BaseButton
                          type='text'
                          size='m'
                          iconPosition='after'
                          icon={<NavigationDownIcon />}
                          width='100%'
                          separate={true}
                          leftalign={true}
                          onClick={(e) => handleItemClick(e, 'moveDown')}
                          bgclass={`bg-grayscale-gray00 border border-grayscale-gray00 pr-2 hover:bg-grayscale-gray01 hover:text-grayscale-gray07
                            active:bg-grayscale-gray01 active:text-grayscale-gray07`}
                          textclass='typo-b14Strong'
                        >
                          Move down
                        </BaseButton>
                      </li>
                    </>
                  )}

                  {type === 'waitlisted' && isPending && (
                    <li>
                      <BaseButton
                        type='text'
                        size='m'
                        iconPosition='after'
                        icon={<MailIcon />}
                        width='100%'
                        separate={true}
                        leftalign={true}
                        onClick={(e) => handleItemClick(e, 'sendOffer')}
                        bgclass={`bg-grayscale-gray00 border border-grayscale-gray00 pr-2 hover:bg-grayscale-gray01 hover:text-grayscale-gray07
                            active:bg-grayscale-gray01 active:text-grayscale-gray07`}
                        textclass='typo-b14Strong'
                      >
                        Send offer reminder
                      </BaseButton>
                    </li>
                  )}

                  {type === 'blocked' && (
                    <li>
                      <BaseButton
                        type='text'
                        size='m'
                        iconPosition='after'
                        icon={
                          blockStatus === 'ACTIVE' ? (
                            <UndoIcon />
                          ) : (
                            <UserMinusIcon />
                          )
                        }
                        width='100%'
                        separate={true}
                        leftalign={true}
                        onClick={(e) =>
                          handleItemClick(
                            e,
                            blockStatus === 'ACTIVE' ? 'unBlock' : 'blockAgain',
                          )
                        }
                        bgclass={`bg-grayscale-gray00 border border-grayscale-gray00 pr-2 hover:bg-grayscale-gray01 hover:text-grayscale-gray07
                          active:bg-grayscale-gray01 active:text-grayscale-gray07`}
                        textclass='typo-b14Strong'
                      >
                        {blockStatus === 'ACTIVE'
                          ? 'Unblock now'
                          : 'Block again'}
                      </BaseButton>
                    </li>
                  )}

                  <li>
                    <BaseButton
                      type='text'
                      size='m'
                      iconPosition='after'
                      icon={<PhoneIcon />}
                      width='100%'
                      separate={true}
                      leftalign={true}
                      onClick={(e) => handleItemClick(e, 'contact')}
                      bgclass={`bg-grayscale-gray00 border border-grayscale-gray00 pr-2 hover:bg-grayscale-gray01 hover:text-grayscale-gray07
                        active:bg-grayscale-gray01 active:text-grayscale-gray07`}
                      textclass='typo-b14Strong'
                    >
                      Contact
                    </BaseButton>
                  </li>

                  {type === 'confirmed' &&
                    status !== 'ABSENT' &&
                    status !== 'ATTENDED' &&
                    !isMvp && (
                      <>
                        <li>
                          <BaseButton
                            type='text'
                            size='m'
                            iconPosition='after'
                            icon={<XCircleIcon />}
                            width='100%'
                            separate={true}
                            leftalign={true}
                            onClick={(e) => handleItemClick(e, 'cancelBooking')}
                            bgclass={`bg-grayscale-gray00 border border-grayscale-gray00 pr-2 hover:bg-grayscale-gray01 hover:text-grayscale-gray07
                            active:bg-grayscale-gray01 active:text-grayscale-gray07`}
                            textclass='typo-b14Strong'
                          >
                            Cancel booking
                          </BaseButton>
                        </li>
                      </>
                    )}

                  {type === 'waitlisted' && (
                    <>
                      <li>
                        <BaseButton
                          type='text'
                          size='m'
                          iconPosition='after'
                          icon={<XCircleIcon />}
                          width='100%'
                          separate={true}
                          leftalign={true}
                          onClick={(e) => handleItemClick(e, 'removeWaitlist')}
                          bgclass={`bg-grayscale-gray00 border border-grayscale-gray00 pr-2 hover:bg-grayscale-gray01 hover:text-grayscale-gray07
                            active:bg-grayscale-gray01 active:text-grayscale-gray07`}
                          textclass='typo-b14Strong'
                        >
                          Remove from waitlist
                        </BaseButton>
                      </li>
                    </>
                  )}

                  {(type === 'confirmed' ||
                    type === 'canceled' ||
                    type === 'waitlisted') &&
                    !isPending && (
                      <li>
                        <BaseButton
                          type='text'
                          size='m'
                          iconPosition='after'
                          icon={isBlocked ? <UndoIcon /> : <UserMinusIcon />}
                          width='100%'
                          separate={true}
                          leftalign={true}
                          onClick={(e) =>
                            handleItemClick(e, isBlocked ? 'unBlock' : 'block')
                          }
                          bgclass={`bg-grayscale-gray00 border border-grayscale-gray00 pr-2 hover:bg-grayscale-gray01 hover:text-grayscale-gray07
                          active:bg-grayscale-gray01 active:text-grayscale-gray07`}
                          textclass='typo-b14Strong'
                        >
                          {isBlocked ? 'Unblock now' : 'Block user'}
                        </BaseButton>
                      </li>
                    )}
                </ul>
              </div>
            </div>
          </>,
          document.body,
        )}
    </>
  );
}
export default WorkshopDetailOptionList;
